import { connect } from 'react-redux';

import DataFormatSettings from '../components/DataFormatSettings';
import { updateReceiptSyncs, updateSettings, updateStaticApiToken, resetStaticApiToken } from '../actions';

import api from '../../../utils/api';

const mapActionCreators = dispatch => ({
    updateSettings: payload => dispatch(updateSettings(payload)),
    updateConfigurations: payload => {
        console.log('DataFormatContainer');
        dispatch(updateReceiptSyncs(payload));
    },
    updateStaticApiToken: payload => {
        dispatch(
            api.actions.settings.updateStaticApiToken({}),
        );
    },
    resetStaticApiToken: payload => dispatch(resetStaticApiToken(payload)),
    onSubmit: payload =>
        dispatch(
            api.actions.user.updateSettings({
                setting: {
                    data_format: payload.get('data_format'),
                    sales_person_id: payload.get('sales_person_id'),
                    include_generic_csv_header: payload.get('include_generic_csv_header'),
                    receipt_syncs: payload.get('receipt_syncs'),
                    advarics_api_url: payload.get('advarics_api_url'),
                    advarics_auth_key: payload.get('advarics_auth_key'),
                },
            })
        ),
});

const selectSettings = state => {
    let data_format = state.settings.get('data_format');
    data_format = state.settings.getIn(['form', 'dataFormatSettings', 'values', 'data_format']);
    console.log(data_format);
    let receipt_syncs = state.settings.getIn(['receipt_syncs']).filter(x => {
        let df = x.get('data_format');
        return df === data_format || df === '';
    });
    console.log(receipt_syncs.toJS());
    return state.settings.setIn(['receipt_syncs'], receipt_syncs);
};

const mapStateToProps = state => ({
    initialValues: state.settings,
    static_api_token: state.static_api_token,
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(DataFormatSettings);
